<template>
  <MensagemErro v-if="erro" :titulo="titulo" :classe="nomeImposto" />
  <LoadingResultado v-else-if="ativarLoading" :titulo="titulo" :classe="nomeImposto" borderTop />
  <MensagemIpi v-else-if="regra == 0" :titulo="titulo" :classe="nomeImposto" />
  <MensagemIcmsInterno v-else-if="icmsAliquota == null" :titulo="titulo" :classe="nomeImposto" />
  <MultiplosSemResultado v-else-if="!exibeImposto" :titulo="titulo" :classe="nomeImposto" />
  <div v-else-if="imposto">
    <h2 class="nome-impressao">ICMS ANTECIPAÇÃO</h2>
    <QuadroAlerta
      v-if="imposto.perguntas.length != 0"
      :classe="nomeImposto"
      :dadosForm="dadosForm"
      @exibeAlerta="alerta => (exibeAlerta = alerta)"
    />
    <QuadroPrincipal
      :borderTop="imposto.perguntas.length == 0 || !exibeAlerta"
      :titulo="!imposto.perguntas.length ? this.titulo : 'SEGMENTO'"
      :classe="nomeImposto"
    >
      <div v-if="!imposto.perguntas.length">
        <ImpostoSemResultado :titulo="imposto.nome" />
      </div>
      <div v-else>
        <PerguntasIcmsAntecipacao
          :key="getRenderKey"
          :imposto="imposto.perguntas"
          :edita="edita"
          :seleciona="seleciona"
          :segmentoSelecionado="segmentoSelecionado"
          :selecionouSegmento="selecionouSegmento"
          :loading="loading"
        />
      </div>
    </QuadroPrincipal>
    <QuadroIcms
      v-if="regrasQuadroIcms"
      :id="id"
      :imposto="imposto"
      :edita="editaIcms"
      :seleciona="selecionaIcms"
      :selecionado="icmsSelecionado"
      :selecionouIcms="selecionouIcms"
      :loading="loading"
      :reduzAliquota="reduzAliquota"
      :classe="nomeImposto"
    />
    <FundoIcms
      v-if="!ativarLoadingSecundario && selecionouIcms"
      :classe="nomeImposto"
      :fundo="imposto.fundo"
      :seleciona="selecionaFundo"
      :fundoSelecionado="fundoSelecionado"
      :selecionouFundo="selecionouFundo"
      :edita="editaFundo"
      :loading="loading"
      :aliquotaEfetivaSelecionada="aliquotaEfetivaSelecionada"
    />
    <BeneficiosIcms
      v-if="
        (!!imposto.beneficio.length || alteracaoImportacao) &&
          selecionouIcms &&
          !ativarLoadingTerciario &&
          icmsSelecionado.label != 'Não Incidência'
      "
      :key="forceRerenderKeyBeneficios"
      :beneficios="imposto.beneficio"
      :beneficioSelecionado="beneficioSelecionado"
      :classe="nomeImposto"
      :seleciona="selecionaBeneficio"
      :selecionouBeneficio="selecionouBeneficio"
      :loading="loading"
    />
    <ResultadoAntecipacao
      v-if="resultadoAntecipacao && !ativarLoadingQuaternario && !ativarLoadingTerciario"
      :dados="resultadoAntecipacao"
      :classe="nomeImposto"
      :mvaSelecionado="mvaSelecionado"
      :selecionouMva="selecionouMva"
      :selecionaMva="selecionaMva"
      :editaMva="editaMva"
    />

    <LoadingResultado v-if="loading" :titulo="''" :classe="nomeImposto" />
  </div>
</template>

<script>
import rotaBufferMixin from "@/mixins/rotaBufferMixin";

import BeneficiosIcms from "@/components/BeneficiosIcms/BeneficiosIcms.vue";
import FundoIcms from "@/components/FundoIcms/FundoIcms.vue";
import ImpostoSemResultado from "@/components/ImpostoSemResultado/ImpostoSemResultado.vue";
import LoadingResultado from "@/components/LoadingResultado/LoadingResultado.vue";
import MensagemIcmsInterno from "@/components/MensagemIcmsInterno/MensagemIcmsInterno.vue";
import MensagemIpi from "@/components/MensagemIpi/MensagemIpi.vue";
import MensagemErro from "@/components/MensagemErro/MensagemErro.vue";
import MultiplosSemResultado from "@/components/ImpostoSemResultado/MultiplosSemResultado.vue";
import PerguntasIcmsAntecipacao from "@/components/PerguntasIcmsAntecipacao/PerguntasIcmsAntecipacao.vue";
import QuadroAlerta from "@/components/QuadroAlerta/QuadroAlerta.vue";
import QuadroIcms from "@/components/QuadroIcms/QuadroIcms.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import ResultadoAntecipacao from "@/components/ResultadoAntecipacao/ResultadoAntecipacao.vue";

import { mapActions, mapGetters } from "vuex";
export default {
  name: "IcmsAntecipacao",

  mixins: [rotaBufferMixin],

  props: {
    id: String | Number,
    buscarImposto: Function,
    tributoAtivo: String,
    exibeImposto: Boolean,
    limparImpostos: Boolean
  },

  inject: ["alteracaoImportacao"],

  components: {
    BeneficiosIcms,
    FundoIcms,
    ImpostoSemResultado,
    LoadingResultado,
    MensagemIcmsInterno,
    MensagemIpi,
    MensagemErro,
    MultiplosSemResultado,
    PerguntasIcmsAntecipacao,
    QuadroAlerta,
    QuadroIcms,
    QuadroPrincipal,
    ResultadoAntecipacao
  },

  data() {
    return {
      exibeAlerta: false,
      titulo: "ICMS ANTECIPAÇÃO",
      ativarLoading: false,
      ativarLoadingSecundario: false,
      ativarLoadingTerciario: false,
      ativarLoadingQuaternario: false,
      ativarLoadingQuinario: false,
      beneficiosKey: 0,
      nomeImposto: "antecipacao",
      imposto: null,
      segmentoSelecionado: {},
      icmsSelecionado: {},
      fundoSelecionado: {},
      beneficioSelecionado: {},
      resultadoAntecipacao: null,
      mvaSelecionado: {},
      selecionouSegmento: false,
      selecionouIcms: false,
      selecionouFundo: false,
      selecionouBeneficio: false,
      selecionouMva: false,
      requerIcms: true,
      requerFundo: true,
      requerMva: true,
      dadosForm: {},
      regra: 0,
      icmsAliquota: null,
      icmsAliquotaBackup: null,
      forceRerenderKeyBeneficios: 0,
      reduzAliquota: 0,
      erro: false,
      isencaoAntecipacao: {
        dados: [
          {
            label: "Inaplicabilidade da Antecipação Tributária",
            texto_inaplicabilidade:
              "Não se aplica a Antecipação Tributária, caso a operação esteja sujeita a Não Incidência do ICMS.",
            id_imposto: 100
          }
        ]
      }
    };
  },

  created() {
    this.setSelecao({
      selecao: { selecionouIcmsAntecipacao: this.selecionouIcmsAntecipacao },
      id: this.id
    });
  },

  updated() {
    if (this.selecionouIcmsAntecipacao) {
      this.setLog(this.impressaoLog);
    }
  },

  watch: {
    async tributoAtivo(newValue) {
      this.erro = false;
      // PUXA VALOR DE REGRA DO IPI QUANDO TROCA DE ABA
      this.regra = this.getDadosForm[this.id].regra;
      // PUXA VALOR DE ALÍQUOTA DO ICMS QUANDO TROCA DE ABA
      this.icmsAliquota = this.getDadosForm[this.id].aliquotaIcmsSelecionada;

      // VERIFICA SE HOUVE TROCA DE ALÍQUOTA DO ICMS INTERNO
      if (this.icmsAliquota != this.icmsAliquotaBackup) {
        this.imposto = null;
      }

      if (
        newValue == this.nomeImposto &&
        this.regra != 0 &&
        !this.imposto &&
        !this.ativarLoading &&
        this.icmsAliquota != null &&
        this.exibeImposto
      ) {
        this.edita();
        // ATUALIZA O BACKUP DA ALIQUOTA PARA FUTURAS VERIFICAÇÕES
        this.icmsAliquotaBackup = this.icmsAliquota;

        this.dadosForm = { ...this.getDadosForm[this.id] };
        this.ativarLoading = true;
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            [this.imposto] = await this.buscarImposto({
              imposto: this.nomeImposto,
              idCenario: this.id
            });
            this.imposto = { ...this.imposto, nome: "ICMS Antecipação" };
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoading = false;
            }
          }
        }
        this.ativarLoading = false;
      }
    },

    limparImpostos(newValue) {
      if (newValue) {
        this.imposto = null;
        this.edita();
      }
    },

    loading() {
      this.$emit("loading", this.loading);
    },

    selecionouIcmsAntecipacao() {
      this.setSelecao({
        selecao: { selecionouIcmsAntecipacao: this.selecionouIcmsAntecipacao },
        id: this.id
      });
    }
  },

  computed: {
    ...mapGetters("form", ["getDadosForm"]),
    ...mapGetters("reRender", ["getRenderKey"]),

    loading() {
      if (
        this.ativarLoading ||
        this.ativarLoadingSecundario ||
        this.ativarLoadingTerciario ||
        this.ativarLoadingQuaternario ||
        this.ativarLoadingQuinario
      ) {
        return true;
      }
      return false;
    },

    regrasQuadroIcms: function() {
      return (
        !!this.imposto.icms &&
        !this.ativarLoadingSecundario &&
        this.selecionouSegmento &&
        this.segmentoSelecionado.id_imposto != 100
      );
    },

    aliquotaEfetivaSelecionada() {
      if (this.selecionouIcms && this.selecionouFundo) {
        // CÁLCULO DE ALÍQUOTA EFETIVA BASEADO NA REGRA DO FUNDO
        if (this.fundoSelecionado.regra_fundo == 2) {
          this.reduzAliquota = this.fundoSelecionado.aliquota;
          return Number(this.icmsSelecionado.aliquota);
        } else {
          this.reduzAliquota = 0;
          return Number(this.icmsSelecionado.aliquota) + Number(this.fundoSelecionado.aliquota);
        }
        // FIM
      }
      this.reduzAliquota = 0;
      return null;
    },

    selecionouIcmsAntecipacao() {
      const selecionou = [
        this.selecionouSegmento,
        !this.requerIcms || this.selecionouIcms,
        !this.requerFundo || this.selecionouFundo,
        !this.requerMva || this.selecionouMva
      ];
      // DEBUG CONSOLE
      // console.log(selecionou);
      return !selecionou.filter(boolean => boolean == false).length;
    },

    impressaoLog() {
      let log = {
        logIcmsAntecipacao: {
          perguntas: this.segmentoSelecionado,
          icms: this.icmsSelecionado,
          fundo: this.fundoSelecionado,
          beneficio: this.beneficioSelecionado,
          antecipacao: this.resultadoAntecipacao,
          mva: this.mvaSelecionado
        }
      };
      return log;
    }
  },

  methods: {
    ...mapActions("tributosSelecionados", ["setSelecao"]),
    ...mapActions("logResultados", ["setLog"]),

    padronizaRequerimentosImpressao(boolean) {
      this.requerIcms = boolean;
      this.requerFundo = boolean;
      this.requerMva = boolean;
    },

    seleciona(imposto) {
      if (imposto.id_imposto == 100) {
        this.padronizaRequerimentosImpressao(false);
      }
      this.segmentoSelecionado = imposto;
      this.selecionouSegmento = true;
    },

    async selecionaIcms(imposto) {
      this.resultadoAntecipacao = null;
      this.icmsSelecionado = imposto;
      this.selecionouIcms = true;

      // PAYLOAD
      this.dadosForm.id_previa = this.segmentoSelecionado.id_tributacao;
      this.dadosForm.v_aliquota = this.icmsSelecionado.aliquota;
      this.dadosForm.id_beneficio = null;
      this.dadosForm.id_beneficio_uf = null;
      // FIM

      // BUSCA RESULTADO PARA IMPOSTO DO ANTECIPAÇÃO
      if (imposto.label != "Não Incidência") {
        this.ativarLoadingTerciario = true;
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            this.resultadoAntecipacao = await this.chamadaRota(
              "Cenario/obterImpostoAntecipacao",
              this.dadosForm
            );
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoadingTerciario = false;
            }
          }
        }
        this.ativarLoadingTerciario = false;
        this.requerIcms = this.imposto ? !!this.imposto.icms.length : true;
        this.requerFundo = this.imposto ? !!this.imposto.fundo.dados.length : true;
        this.requerMva = this.resultadoAntecipacao ? !!this.resultadoAntecipacao.base.length : true;
      } else {
        this.resultadoAntecipacao = this.isencaoAntecipacao;
        this.padronizaRequerimentosImpressao(false);
      }

      // FIM
    },

    selecionaBeneficio(id) {
      this.resultadoAntecipacao = null;
      this.beneficios = this.imposto.beneficio.map(beneficio => {
        if (beneficio.id_imposto == id) {
          this.beneficioSelecionado = beneficio.selecionado ? beneficio : {};
          this.selecionouBeneficio = beneficio.selecionado;
          this.beneficioClasse = beneficio.label;

          this.dadosForm.id_beneficio = this.selecionouBeneficio
            ? beneficio.id_tributacao_geral
            : null;
          this.dadosForm.id_beneficio_uf = this.selecionouBeneficio
            ? beneficio.id_tributacao_uf
            : null;
        } else {
          beneficio.selecionado = false;
        }
        return beneficio;
      });
      this.forceRerenderKeyBeneficios += 1;

      //CHAMA OU NÃO O ANTECIPAÇÃO QUANDO SELECIONADO BENEFÍCIO
      this.chamadaBeneficio();
    },

    selecionaFundo(imposto) {
      this.fundoSelecionado = imposto;
      this.selecionouFundo = true;
    },

    selecionaMva: function(mva) {
      this.mvaSelecionado = mva;
      this.selecionouMva = true;
    },

    async chamadaBeneficio() {
      this.ativarLoadingQuaternario = true;
      if (this.selecionouBeneficio) {
        // CHAMA RESULTADO DO ANTECIPAÇÃO CASO NÃO SEJA BENEFÍCIO DE ISENÇÃO
        if (this.beneficioClasse != "Isenção") {
          let tentativas = 0;
          while (tentativas < 3) {
            try {
              this.resultadoAntecipacao = await this.chamadaRota(
                "Cenario/obterImpostoAntecipacao",
                this.dadosForm
              );
              tentativas = 3;
            } catch (error) {
              tentativas++;
              console.error(`${tentativas}ª tentativa`);
              if (tentativas === 3) {
                console.error(error);
                this.erro = true;
                this.ativarLoadingQuaternario = false;
              }
            }
          }
        } else {
          // SE FOR BENEFÍCIO DE ISENÇÃO MOSTRA ALERTA DO FRONT
          this.resultadoAntecipacao = this.isencaoAntecipacao;
        }
      } else {
        // REINICIA PAYLOAD
        this.dadosForm.id_beneficio = null;
        this.dadosForm.id_beneficio_uf = null;
        // FIM
        // EXIBE RESULTADO SEM BENEFÍCIO
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            this.resultadoAntecipacao = await this.chamadaRota(
              "Cenario/obterImpostoAntecipacao",
              this.dadosForm
            );
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoadingQuaternario = false;
            }
          }
        }
      }
      this.ativarLoadingQuaternario = false;
    },

    edita() {
      this.segmentoSelecionado = {};
      this.selecionouSegmento = false;
      this.icms = null;

      this.editaIcms();
    },

    editaIcms() {
      this.icmsSelecionado = {};
      this.selecionouIcms = false;
      this.beneficios = null;
      this.resultadoAntecipacao = null;
      this.selecionouMva = false;
      this.reduzAliquota = 0;
      this.padronizaRequerimentosImpressao(true);
      this.editaFundo();
      this.editaBeneficios();
      this.editaMva();
    },

    editaFundo() {
      this.fundoSelecionado = null;
      this.selecionouFundo = false;
    },

    editaBeneficios() {
      this.beneficioSelecionado = {};
      this.selecionouBeneficio = false;
      this.resultadoAntecipacao = null;
      if (this.imposto && this.imposto.beneficio) {
        this.imposto.beneficio.map(beneficio => {
          beneficio.selecionado = false;
        });
      }
    },

    editaMva: function() {
      this.mvaSelecionado = {};
      this.selecionouMva = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
